const keys = {
  escape: { key: 'Escape' },
} as const;

export default keys;
